export default "__VITE_ASSET__d5c2d3ab__"